<template>
  <div id="notfound">
    <br>
    現在このURLは使用されておりません
  </div>
</template>

<script>
export default {};
</script>

<style></style>
